import { render } from "./Currencies.vue?vue&type=template&id=66f3e0a4"
import script from "./Currencies.vue?vue&type=script&lang=js"
export * from "./Currencies.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__